import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { PROJECT_PATH } from "../../configs/constants/paths";

const ProjectBreadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const locationParts = pathname.split("/");
  
  return (
    <div
      className={`pt-3 project-breadcrumb container ${
        locationParts[2] === "screens" || locationParts[2] === "view-list" ? "" : "hidden"
      }`}
    >
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate(PROJECT_PATH)}>
          My projects
        </Breadcrumb.Item>
        <Breadcrumb.Item
          onClick={() => navigate(`${PROJECT_PATH}/screens/${locationParts[3]}`)}
          active={locationParts[2] !== "view-list"}
        >
          Overview project images
        </Breadcrumb.Item>
        <Breadcrumb.Item
          className={locationParts[2] !== "view-list" ? "hidden" : ""}
          active
        >
          Image link-settings{" "}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );
};

export default ProjectBreadcrumb;
